<template>
  <div id="app" class="app" @click="isdo">
    <keep-alive>
      <router-view v-if="isRouterAlive && $route.meta.keepAlive" />
    </keep-alive>
    <router-view
      v-if="isRouterAlive && (!$route.meta || !$route.meta.keepAlive)"
    />
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },

  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    isdo(e) {
      if (this.$route.name !== "survey-edit") {
        return false;
      }
      let failureClass = [
        "wenjuan",
        "main",
        "survey_main_wrap",
        "survey_prefix_wrap",
        "survey_question_wrap",
        "survey_main",
        "question_type_wrap",
        "sidebar",
        "survey_suffix_wrap",
        "release_share_box",
        "release_share_btn"
      ];
      let className = e.target.className;
      if (failureClass.indexOf(className) >= 0) {
        this.$store.dispatch("setActiveQuestion", {});
      }

      if (!this.selectElement(e.target)) {
        this.$store.dispatch("setActiveOption", {});
      }
      if (!this.selectElement1(e.target)) {
        this.$store.dispatch("setBubbleParameter", {});
      }
    },
    selectElement(el) {
      if (
        el.className === "setting_main_wrap" ||
        el.className === "fa fa-cog fa-lg setting"
      )
        return true;
      let e = el.parentElement;
      if (!e) return false;
      let className = e.className;
      if (
        className === "setting_main_wrap" ||
        el.className === "fa fa-cog fa-lg setting"
      ) {
        return true;
      } else {
        return this.selectElement(e);
      }
    },
    selectElement1(el) {
      if (
        el.className === "jsBubble_s" ||
        el.className === "btn-text btn-add-more"
      )
        return true;
      let e = el.parentElement;
      if (!e) return false;
      let className = e.className;
      if (
        className === "jsBubble_s" ||
        el.className === "btn-text btn-add-more"
      ) {
        return true;
      } else {
        return this.selectElement1(e);
      }
    }
  }
};
</script>
<style lang="less">
@import "~@/assets/style/variables.less";
@import "~@/assets/style/common.css";
@import "~@/page/user/login-register.less";

body {
  color: #333;
  font-family: Helvetica Neue, PingFang SC, Hiragino Sans GB, HeitiSC, Helvetica,
    Arial, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif;
  min-width: 1200px;
}

// * {
//   margin: 0;
//   padding: 0;
//   outline: none;
// }

ol,
ul,
li {
  list-style: none;
}

#app {
  box-sizing: border-box;
}

a {
  text-decoration: none;
  outline: none;
  cursor: pointer;
}

//  消除图片下的2px
// img {
//   vertical-align: middle;
// }

.wrapper {
  width: 1200px;
  margin: 0 auto;
}

.pagination {
  background-color: white;
  text-align: center;
  padding: 10px 0;
}

// 覆写 element ui 的 el-main
.el-main {
  padding: 0 !important;
}

// 标题签名的 圆柱形 dot
.dot {
  background: @deepblue;
  display: inline-block;
  width: 5px;
  height: 16px;
  margin-bottom: -2px;
  border-radius: 5px;
  margin-right: 5px;
}

.highlight {
  color: @deepblue;
}

.weak {
  color: lightgray;
}

// body .el-table th.gutter {
//   display: table-cell !important;
// }

// body .el-table colgroup.gutter {
//   display: table-cell !important;
// }

.wrap {
  width: 1200px;
  margin: 0 auto;
}

#container {
  padding-top: 60px;
}

.el-button.plain_primary.is-plain {
  background-color: #ffffff;
  border-color: #1d82fc;
  color: #1d82fc;

  &:hover {
    color: #1d82fc;
    border-color: #1d82fc;
    background-color: #e8f3ff;
  }
}

.app-scrollbar {
  height: 100%;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>